// removed by extract-text-webpack-plugin
module.exports = {"portfolioIntroBanner":"_8nJOgNuLNL3DZAVUFeSfd","leftCol":"_2Pngx9HCRPKk3hJGzAQI1d","content":"_1bRocyBYPMs8Bt3bgsgyp9","rightCol":"_3dbiXsedPyaKMs6ZbJ_qjD","icon1":"_2mIsZDW3qh6B_K7oEmpV1_","icon2":"NE2bcsIJFaA8npL65Aya4"};


/*****************
 ** WEBPACK FOOTER
 ** ../components/PortfolioIntroBanner.module.scss
 ** module id = 1772
 ** module chunks = 0
 **/